/**
 * Lazy-load a widget's HTML content via GET and insert it into the DOM.
 *
 * @param {string}   containerSelector  jQuery selector for the target element.
 * @param {string}   url                GET endpoint that returns HTML.
 * @param {Function} [callback]         Optional function called after content is inserted.
 */
export function initLazyWidget(containerSelector, url, callback) {
  $.get(url).done(function (data) {
    if (data.length > 0) {
      $(containerSelector).html(data).show();
      if (typeof callback === 'function') {
        callback();
      }
    }
  });
}
